/* eslint-disable prettier/prettier */
import { useState, useCallback, useEffect } from 'react';
import { courseModuleService } from '../services/courseModule.service';
import {
  CourseModule,
  Lesson,
  CreateModulePayload,
  UpdateModulePayload,
  CreateLessonPayload,
  UpdateLessonPayload,
} from '../services/courseModule.service';

// ==============================
// Hook
// ==============================

function mapLesson(
  lesson: Lesson
): Lesson & { startDate?: string; endDate?: string } {
  return {
    ...lesson,
    startDate: lesson.scheduledstarttime || '',
    endDate: lesson.scheduledendtime || '',
  };
}

function mapModule(module: CourseModule): CourseModule & { startDate?: string; endDate?: string } {
  console.log('MAP MODULE INPUT', module);
  return {
    ...module,
    startDate: module.startdate || '',
    endDate: module.enddate || '',
    lessons: (module.lessons || []).map(mapLesson),
  };
}

export const useCourseModules = () => {
  const [modules, setModules] = useState<CourseModule[]>([]);
  const [selectedModule, setSelectedModule] = useState<CourseModule | null>(
    null
  );
  const [lessons, setLessons] = useState<Lesson[]>([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // ==========================
  // MODULE APIs
  // ==========================

  const fetchCourseModules = useCallback(async (courseId: string) => {
    setLoading(true);
    setError(null);

    try {
      const res = await courseModuleService.getCourseModules(courseId);

      console.log('🔥 RES', res);

      if (res.success) {
        const mapped = (res.data || []).map(mapModule);

        console.log('🔥 MAPPED MODULES', mapped);

        setModules(mapped);

        return mapped;
      }

      setError(res.message || 'Failed to fetch modules');
      return [];
    } catch (err: any) {
      console.error('FETCH MODULE ERROR', err);
      setError(err?.message || 'Failed to fetch modules');
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    console.log('🔥 MODULE STATE', modules);
  }, [modules]);


  const fetchModuleById = useCallback(async (moduleId: string) => {
    setLoading(true);
    setError(null);

    try {
      const res = await courseModuleService.getModuleById(moduleId);

      if (res.data.success) {
        const mapped = mapModule(res.data.data);

        setSelectedModule(mapped);
        setLessons(mapped.lessons || []);
      } else {
        setError(res.data.message || 'Failed to fetch module');
      }
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const createModule = useCallback(async (payload: CreateModulePayload) => {
    setLoading(true);
    setError(null);

    try {
      const res = await courseModuleService.createModule(payload);

      if (res.data.success) {
        const mapped = mapModule(res.data.data);

        setModules(prev => [...prev, mapped]);
        return mapped;
      } else {
        setError(res.data.message || 'Failed to create module');
      }
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const updateModule = useCallback(
    async (id: string, payload: UpdateModulePayload) => {
      setLoading(true);
      setError(null);

      try {
        const res = await courseModuleService.updateModule(id, payload);

        if (res.data.success) {
          const mapped = mapModule(res.data.data);

          setModules(prev =>
            prev.map(m => (m.id === id ? mapped : m))
          );

          return mapped;
        } else {
          setError(res.data.message || 'Failed to update module');
        }
      } catch (err: any) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const deleteModule = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);

    try {
      const res = await courseModuleService.deleteModule(id);

      if (res.data.success) {
        setModules(prev => prev.filter(m => m.id !== id));
      } else {
        setError(res.data.message || 'Failed to delete module');
      }
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const reorderModules = useCallback(
    async (
      courseId: string,
      reorderedModules: { id: string; orderindex: number }[]
    ) => {
      setLoading(true);
      setError(null);

      try {
        const res = await courseModuleService.reorderModules(
          courseId,
          reorderedModules
        );

        if (!res.data.success) {
          setError(res.data.message || 'Failed to reorder modules');
        }
      } catch (err: any) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  // ==========================
  // LESSON APIs
  // ==========================

  const fetchModuleLessons = useCallback(async (moduleId: string) => {
    setLoading(true);
    setError(null);

    try {
      const res = await courseModuleService.getModuleLessons(moduleId);

      if (res.data.success) {
        const mapped = res.data.data.map(mapLesson);

        setLessons(mapped);
        return mapped;
      } else {
        setError(res.data.message || 'Failed to fetch lessons');
        return [];
      }
    } catch (err: any) {
      setError(err);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  // const createLesson = useCallback(async (payload: CreateLessonPayload) => {
  //   setLoading(true);
  //   setError(null);
  //   try {
  //     const res = await courseModuleService.createLesson(payload);

  //     if (res.success) {
  //       // const mapped = mapLesson(res.data as Lesson);
  //       const mapped = mapLesson(res.data.data);
  //       setLessons(prev => [...prev, mapped]);

  //       return mapped;
  //     }

  //     return null;
  //   } catch (err: any) {
  //     setError(err);
  //     return null;
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);
  const createLesson = useCallback(async (payload: CreateLessonPayload) => {
  setLoading(true);
  setError(null);

  try {
    const res = await courseModuleService.createLesson(payload);

    if (!res.success) {
      throw new Error(res.message);
    }
     console.log("FULL RESPONSE", res);
console.log("DATA", res.data);
    // const mapped = mapLesson(res.data.data);
    // const mapped = mapLesson(res.data);
    // console.log("LESSON DATA", res.data.data);

const mapped = mapLesson(res.data);
    setLessons(prev => [...prev, mapped]);

    return mapped;
  } catch (err: any) {
    setError(err?.message || err);
    throw err; // important
  } finally {
    setLoading(false);
  }
}, []);


  const updateLesson = useCallback(
    async (id: string, payload: UpdateLessonPayload) => {
      setLoading(true);
      setError(null);

      try {
        const res = await courseModuleService.updateLesson(id, payload);

        if (res.data.success) {
          const mapped = mapLesson(res.data.data);

          setLessons(prev =>
            prev.map(l => (l.id === id ? mapped : l))
          );

          return mapped;
        } else {
          setError(res.data.message || 'Failed to update lesson');
        }
      } catch (err: any) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const deleteLesson = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);

    try {
      const res = await courseModuleService.deleteLesson(id);

      if (res.data.success) {
        setLessons(prev => prev.filter(l => l.id !== id));
      } else {
        setError(res.data.message || 'Failed to delete lesson');
      }
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const reorderLessons = useCallback(
    async (
      moduleId: string,
      reorderedLessons: { id: string; orderindex: number }[]
    ) => {
      setLoading(true);
      setError(null);

      try {
        const res = await courseModuleService.reorderLessons(
          moduleId,
          reorderedLessons
        );

        if (!res.data.success) {
          setError(res.data.message || 'Failed to reorder lessons');
        }
      } catch (err: any) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  // ==========================
  // RETURN
  // ==========================

  return {
    // state
    modules,
    selectedModule,
    lessons,
    loading,
    error,

    // module actions
    fetchCourseModules,
    fetchModuleById,
    createModule,
    updateModule,
    deleteModule,
    reorderModules,

    // lesson actions
    fetchModuleLessons,
    createLesson,
    updateLesson,
    deleteLesson,
    reorderLessons,
  };
};
